import CARD_STYLES from "../styles";

export const BODY_STYLE: React.CSSProperties = {
  ...CARD_STYLES.body,
  fontFamily: "HelveticaNeue",
  fontSize: "1rem",
  color: "#1f2226",
};

export const SECURITY_QUESTION_STYLE: React.CSSProperties = {
  marginBottom: "0.5rem",
  fontSize: "0.85rem",
  color: "#667580",
  fontWeight: "bold"
};

export const INPUT_CONTAINER_STYLE: React.CSSProperties = {
  display: "flex",
  gap: "0.5rem",
  marginBottom: "1rem",
  alignItems: "center",
};

export const INPUT_STYLE: React.CSSProperties = {
  flex: 1,
};

export const RESET_BUTTON_STYLE: React.CSSProperties = {
  margin: "0.5rem auto",
  display: "block",
};

export const RESET_SECTION_STYLE: React.CSSProperties = {
  borderTop: "1px solid #e8e8e8",
  paddingTop: "1rem",
  marginTop: "1rem",
};